import React from "react"
import PropTypes from "prop-types"
import { X } from "lucide-react"
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
  Button,
  CardHeader,
  CardTitle,
  CardContent,
} from "ksc-portal-common-components/shadcn"
import { ENTER_TOTP_TITLE } from "../constants"

const EnterTOTP = ({
  enterTOTPCode,
  updateTotpCode,
  qrCode,
  errorMessage,
  backToLogin,
}) => (
  <>
    <CardHeader>
      <Button
        onClick={backToLogin}
        variant="ghost"
        size="icon"
        className="absolute right-3 top-3 rounded-full"
        aria-label="Close"
        data-testid="back-button"
      >
        <X className="h-4 w-4" />
      </Button>
      <CardTitle className="text-center text-xl font-medium text-foreground">
        {ENTER_TOTP_TITLE}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <form onSubmit={enterTOTPCode}>
        <div className="flex flex-col items-center">
          <br />
          {qrCode && (
            <canvas id="login-qr-canvas" data-testid="mfa-enabled-qr-code" />
          )}
          <InputOTP
            ref={updateTotpCode}
            maxLength={6}
            onChange={(value) => value.length === 6 && enterTOTPCode()}
            data-testid="login-enter-totp-code"
          >
            <InputOTPGroup>
              <InputOTPSlot index={0} />
              <InputOTPSlot index={1} />
              <InputOTPSlot index={2} />
              <InputOTPSlot index={3} />
              <InputOTPSlot index={4} />
              <InputOTPSlot index={5} />
            </InputOTPGroup>
          </InputOTP>
          {!!errorMessage && (
            <div className="text-destructive text-xs">{errorMessage}</div>
          )}
          <Button type="submit" variant="default" className="mt-8 w-full">
            Enter OTP
          </Button>
        </div>
      </form>
    </CardContent>
  </>
)

EnterTOTP.propTypes = {
  enterTOTPCode: PropTypes.func.isRequired,
  updateTotpCode: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  qrCode: PropTypes.string,
  backToLogin: PropTypes.func.isRequired,
}

EnterTOTP.defaultProps = {
  qrCode: "",
  errorMessage: "",
}

export default EnterTOTP
